import React, { useState } from 'react'
import filterStyles from "./selectFieldComponent.module.css";


const SelectFieldComponent = ({ optionsList, firstOption, onSelectChange, style }) => {
    const [selectedValue, setSelectedValue] = useState('');

    const handleSelectChange = (event) => {
        const value = event.target.value;
        setSelectedValue(value);
        onSelectChange(value); // Send selected value to parent
    };

    return (
        <div>
            <select style={style} className={`${filterStyles.select}`} value={selectedValue} onChange={handleSelectChange}>
                <option value="" selected disabled hidden> {firstOption} </option>
                {
                    optionsList.map(({ value, label }, index) => (
                        <option value={value} key={index}> {label} </option>
                    ))
                }
            </select>
        </div >
    )
}

export default SelectFieldComponent
